import React, { Component } from 'react';
import './CompetitorSelect.css';
import _ from 'lodash';

class CompetitorSelect extends Component {
    state = {
        circleData: [],
        checkedData: []
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    componentWillMount(){
        this.setState({ checkedData : this.props.checkedData });
        this.props.prioritiser.map((segmentItem, key) => {

            // console.log(segmentItem.checked)
            //debugger
            this.onChangeCheckbox(segmentItem.segmentId, segmentItem,  segmentItem.checked);
        })
    }

    onChangeCheckbox = (id, segmentItem,  val) => {
        if(val){
            this.state.checkedData.push(id)
        }else{
            _.remove(this.state.checkedData, (comment) => {
                return (comment ===  id)
            });
        }

        this.props.competitorSelectCheckChanges(val, segmentItem, this.state.checkedData)
    }

    render() {
        let resourceInputs = this.props.prioritiser.map((segmentItem, key) => {
            //debugger
            // console.log('segmentItem', segmentItem)
            let checkState =  _.find(this.props.checkedData, (s) => s === segmentItem.segmentId) ? true : false;

            if (this.props.groupId === segmentItem.groupId) {
                return (
                    <div className='input-group'>
                        <label>
                            <input type='checkbox' disabled checked={segmentItem.checked}
                            onChange={() => this.onChangeCheckbox(segmentItem.segmentId, segmentItem,  !checkState)}
                            />
                            {segmentItem.segmentName}
                        </label>
                    </div>
                )
            }

        })

        return (
            <div className="resource-box competitor-select-card">
                <p>Segments</p>
                {resourceInputs}
            </div>

        )
    }
}
export default (CompetitorSelect);



// WEBPACK FOOTER //
// ./src/components/Prioritizer/Result/TabContent/CompetitorSelect/CompetitorSelect.jsx